import { openTool } from '@app/store/actions.js';
import { isToolOpen } from '@app/store/selectors.js';
import { useMessages } from '@features/l10n/l10nInjector.js';
import { LongPressTooltip } from '@shared/components/LongPressTooltip.js';
import { useAppSelector } from '@shared/hooks/useAppSelector.js';
import type { ReactElement } from 'react';
import { Button } from 'react-bootstrap';
import { FaRoute } from 'react-icons/fa';
import { useDispatch } from 'react-redux';

export function RoutePlannerToggleButton(): ReactElement | undefined | false {
  const routePlannerOpen = useAppSelector((state) =>
    isToolOpen(state, 'route-planner'),
  );

  const m = useMessages();

  const dispatch = useDispatch();

  return (
    <LongPressTooltip label={m?.tools.routePlanner}>
      {({ props }) => (
        <Button
          {...props}
          variant="dark"
          disabled={routePlannerOpen}
          onClick={() => dispatch(openTool('route-planner'))}
        >
          <FaRoute />
        </Button>
      )}
    </LongPressTooltip>
  );
}
